import React from 'react'
import ImpactStats from '../components/Main/ImpactStats'
import ImageCallout from '../components/Main/ImageCallout'
import CtaBanner from '../components/Main/CtaBanner'
import Page from '../components/Page'

export default function OurImpact (props) {
  const {
    //Hero Section fields
    intro_image: {
      url: introImage,
      alt: alt,
      height: height,
      width: width,
      id: imageId
    },
    intro_heading: introHeading,
    intro_paragraph: introParagraph,

    //Impact Stats
    impact_stats_heading: impactHeading,
    stats_paragraph: impactParagraph,
    impact_stats_stats: impactStats,

    // callout_upper_images: calloutImages,
    callout_upper_images: calloutImages,
    callout_upper_heading: calloutHeading,
    callout_upper_sub_heading: calloutSubheading,
    callout_upper_paragraph: calloutParagraph,
    callout_upper_link: { url: calloutUrl, title: calloutLinkTitle },
    callout_upper_sub_text: calloutSubText,
    callout_upper_column_order: colOrder,

    //callout_fourth_image:
    callout_fourth_image: { url: fourthImageUrl },
    callout_fourth_image_caption: fourthCaption,
    callout_fourth_heading: fourthHeading,
    callout_fourth_sub_heading: fourthSubheading,
    callout_fourth_paragraph: fourthParagraph,
    callout_fourth_link: { url: fourthUrl, title: fourthLinkTitle },
    callout_fourth_column_order: fourthColOrder,
    intro_link_icon: fourthIcon,
   
    //callout_about_image:
    callout_about_image: { url: aboutImageUrl },
    callout_about_image_caption: aboutCaption,
    callout_about_heading: aboutHeading,
    callout_about_sub_heading: aboutSubheading,
    callout_about_paragraph: aboutParagraph,
    callout_about_link: { url: aboutUrl, title: aboutLinkTitle },
    callout_about_column_order: aboutColOrder,
    intro_link_icon: aboutIcon,

    //callout_lower_image:
    callout_lower_image: { url: lowerImageUrl },
    callout_lower_image_caption: lowerCaption,
    callout_lower_heading: lowerHeading,
    callout_lower_sub_heading: lowerSubheading,
    callout_lower_paragraph: lowerParagraph,
    callout_lower_link: { url: lowerUrl, title: lowerLinkTitle },
    callout_lower_column_order: lowerColOrder,
    intro_link_icon: lowerIcon,

    //CtaBanner Fields
    cta_heading: ctaHeading,
    cta_link: { url: ctaLink, title: ctaButton }
  } = props.acf

  return (
    <React.Fragment>
      <Page
        title={introHeading}
        body={introParagraph}
        bgImage={introImage}
        bgId={imageId}
        alt={alt}
        height={height}
        width={width}
        slug={'/our-impact'}
      >
        <main id='content'>
          <ImpactStats
            title={impactHeading}
            body={impactParagraph}
            stats={impactStats}
          />
          <ImageCallout
            centered
            array
            title={calloutHeading}
            body={calloutParagraph}
            link={calloutUrl}
            button={calloutLinkTitle}
            images={calloutImages}
          />
          <ImageCallout
            reversed
            title={fourthHeading}
            body={fourthParagraph}
            link={fourthUrl}
            button={fourthLinkTitle}
            image={fourthImageUrl}
          />
          <ImageCallout
            title={aboutHeading}
            body={aboutParagraph}
            link={aboutUrl}
            button={aboutLinkTitle}
            image={aboutImageUrl}
          />
          <ImageCallout
            reversed
            title={lowerHeading}
            body={lowerParagraph}
            link={lowerUrl}
            button={lowerLinkTitle}
            image={lowerImageUrl}
          />
        </main>
        <CtaBanner
          noSlug //the page this is linking to is not handled by /pages/[slug].js
          title={ctaHeading}
          link={ctaLink}
          button={ctaButton}
        />
      </Page>
    </React.Fragment>
  )
}
